import { t } from '@/i18n';

const TransportType = {
    Import: 0,
    Export: 1,
    Other: 2,
    Transfer: 3
};

type TransportType = (typeof TransportType)[keyof typeof TransportType];

// Getters, so a lookup reads the name in the current locale.
const TransportTypeArray = [
    { value: TransportType.Import, get name(): string { return t('transportType.import'); } },
    { value: TransportType.Export, get name(): string { return t('transportType.export'); } },
    { value: TransportType.Other, get name(): string { return t('transportType.other'); } },
    { value: TransportType.Transfer, get name(): string { return t('transportType.transfer'); } }
];

const typeToName = (type: TransportType): string => TransportTypeArray.find(x => x.value === type)?.name ?? '';

export { TransportType, TransportTypeArray, typeToName };